// extracted by mini-css-extract-plugin
module.exports = {"sliderPositionInput":"SliderPositionInput_sliderPositionInput__Dazc_","sliderPositionInputForm":"SliderPositionInput_sliderPositionInputForm__27SMs"};